import { ObjectId } from "mongodb";

export default function objectIdsMatch(id1?: ObjectId | string | null, id2?: ObjectId | string | null) {
    if (!id1 || !id2) {
        return false;
    }

    return id1.toString() === id2.toString();
}
